module.exports = __webpack_public_path__ + "img/cover.51aee38d.webp";